export const EquipmentStrings = {
  equipments: 'Equipment',
  loadingEquipmentList: 'Loading Equipment list...',
  equipmentListError: 'Cannot fetch Equipment list',
  kenNumber: 'KEN number',
  name: 'Name',
  organizations: 'Organizations',
  added: 'Added',
}

export const WebhookStrings = {
  kenExample: 'ken:100554477',
  serialNumber: 'Equipment serial number',
  equipmentDescription:
    'Unique id provided by customer as an internal identification of the equipment within their system',
  equipmentType: 'Equipment type',
  equipmentTypeExamples: [
    'Building',
    'Autowalk',
    'Building Door',
    'Dumbwaiter',
    'Elevator',
    'Escalator',
    'Stairlift',
    'Facadator',
    'Marine Elevator',
    'Marine Escalator',
    'Marine other eq.',
    'Other',
  ],
  directionDesc: ['0: stopped', '1: up', '2: down'],
  equipmentNumberDesc: 'Unique identifer number of an equipment',
  countryCode: 'Code of the country',
  cityName: 'Name of the city',
  countryName: 'Country name',
  postalCode: 'Postal code',
  equipmentDesc: 'Description of the equipment',
  streetName: 'Street name',
}
